import React from "react";
import "./Footer.css";
import { FaYoutube, FaFacebookF, FaInstagram } from 'react-icons/fa';
import { SiGoogle, SiAmazon } from "react-icons/si";
import { AiFillLinkedin } from "react-icons/ai";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col">
          <h3 className="logo">DiscountDost</h3>
          <p>Discover exclusive deals from top restaurants, retailers and more. Save big with DiscountDost!</p>
        </div>
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/deals">Browse All Deals</a></li>
            <li><a href="/how-it-works">How It Works</a></li>
            <li><a href="/partner-with-us">Partner With Us</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/careers">Careers</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Support</h4>
          <ul>
            <li><a href="/ContactForm">Contact Us</a></li>
            <li><a href="/faqs">FAQs</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms-and-conditions">Terms & Conditions</a></li>
          </ul>
        </div>
        <div className="footer-col newsletter">
          <h4>Newsletter</h4>
          <p>Subscribe to get notified about exclusive deals and offers!</p>
          <div className="subscribe-box">
            <input type="email" placeholder="Your email address" />
            <button>Subscribe</button>
          </div>
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="/facebook"><FaFacebookF /></a>
            <a href="/instagram"><FaInstagram /></a>
            <a href="/youtube"><FaYoutube /></a>
          </div>
        </div>
      </div>

      <div className="trusted-by">
        <h4>Trusted by Leading Brands</h4>
        <div className="brand-logos">
          <SiGoogle />
          <AiFillLinkedin />
          <SiAmazon />
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 DiscountDost. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;